// main.js
import { createApp } from "vue";
import App from "./App.vue";
import createStore from "./store";
import createRouter from "./router";
import { createHead } from "@unhead/vue";
import axios from "axios";

// Jangan gunakan vue-easy-lightbox di sini.
// import VueEasyLightbox from "vue-easy-lightbox";

const store = createStore();
const router = createRouter();
const head = createHead();

const app = createApp(App);

app.config.globalProperties.$api = axios.create({
    baseURL: "https://admin.itsyourdayofficial.com/api/",
});

app.use(store);
app.use(router);
app.use(head);

if (window && window.__INITIAL_STATE__) {
    store.state.value = window.__INITIAL_STATE__;
}

app.mount("#app");
